import { useState, useEffect } from 'react'
import PageContainer from '../../components/PageContainer'
import SkinViewer from '../../components/SkinViewer'

async function getSkinInfo(skinName) {
  const res = await fetch(`/api/downloadSkinByName?skinName=${skinName}&skipDownloadIncrement=true`)
  return res.json()
}

const Skin = ({ skin }) => {
  return (
    <PageContainer>
      <h2>{skin.skinName}</h2>
      <p>{skin.downloadCount?.toLocaleString()} downloads</p>

      <SkinViewer skin={skin} />

      <h2>Use this skin in-game</h2>

      <p>
        To use this skin, head into the Store -&gt; Skins -&gt; Custom Skins,
        enter its name ("{skin.skinName.toLowerCase()}") and hit 'Download'. Skin names are
        not case-sensitive.
      </p>
    </PageContainer>
  )
}

export default Skin
export async function getStaticProps(context) {
  const skinName = context.params.skinName.replace(/-/g, ' ')
  const skin = await import('../../lib/serverside/getSkinDetails')
    .then(gSD => gSD.getSkinDetails(skinName))

  if (skin == null) {
    return {
      notFound: true
    }
  }

  skin.skinName = skin.skinName.toUpperCase()

  return { props: { skin } }
}

export async function getStaticPaths() {
  const { skins } = await import('../api/topSkins')
    .then(tS => tS.getTopSkinsData(-1))

  const paths = skins.map(skin => (
    { params: { skinName: skin.skinName } }
  ))

  console.log(paths)

  return { paths, fallback: 'blocking' }
}